import styled from "styled-components";

export const Container = styled.div`
  width: 90vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.5rem 0;
  color: var(--text-primary);
  background: var(--surface-1);
  border-radius: 12px;

  div {
    width: 80vw;
  }

  /* O documento é HTML legado (exportado do Word) com <font color> e <style>
     embutidos; as regras abaixo devolvem o controle das cores ao tema. */
  font,
  p,
  span,
  td,
  th,
  li {
    color: inherit;
  }

  font[color="#38761d"] {
    color: var(--accent);
  }

  font[color="#0070c0"],
  a,
  a:link,
  a:visited {
    color: var(--info);
  }

  table,
  td,
  th {
    border-color: var(--border-default);
  }

  @media (max-width: 700px) { 
    width: 100vw;

    div {
      width: 90vw;
    }
  }
`;
